import {Box} from '@mui/material';
import React from 'react';
import {useNavigate} from 'react-router-dom';

type Props = {
  links: {name: string; url: string | 'back'}[];
};

export default function Breadcrumb(props: Props) {
  const {links} = props;
  const navigate = useNavigate();
  const handleOnClick = (url: string) => {
    if (url === '') {
      return;
    }
    if (url === 'back') {
      return navigate(-1);
    }
    return navigate(url);
  };

  return (
    <Box style={styles.container}>
      <a href="https://www.acep.org/" style={styles.firstLinkStyle}>
        American College of Emergency Physicians
      </a>
      {links.map((link, index) => {
        const isLast = index === links.length - 1;
        return (
          <span
            key={index}
            style={{
              color: isLast ? '#888888' : 'black',
              cursor: isLast ? 'auto' : 'pointer',
              fontWeight: isLast ? 'normal' : '600',
            }}>
            <span style={styles.gapStyle}>/</span>
            <span
              onClick={() => handleOnClick(link.url)}
              style={styles.linkStyle}>
              {link.name}
            </span>
          </span>
        );
      })}
    </Box>
  );
}

const styles = {
  container: {
    paddingBottom: 50,
  },
  linkStyle: {
    fontSize: 12,
    lineHeight: 2.0,
    textDecoration: 'none',
    letterSpacing: 1,
    color: 'inherit',
  },
  gapStyle: {
    paddingLeft: 10,
    paddingRight: 10,
  },
  firstLinkStyle: {
    fontSize: 12,
    textDecoration: 'none',
    letterSpacing: 1,
    color: 'black',
    cursor: 'pointer',
    fontWeight: '600',
    lineHeight: 0.96,
  },
};
